import { CategoryEnhancedGridSectionResult } from "~/common/Store/models/Category";

// List of featured brands ordered alphabetically
const brandSection: CategoryEnhancedGridSectionResult[] = [
  {
    description: "Acopa",
    link: "/vendor/acopa.html",
    imagePath: "/images/vendor/small/20200608/acopa_original_logo_hr.jpg",
  },
  {
    description: "Avantco\u000AEquipment",
    link: "/vendor/avantco-equipment.html",
    imagePath: "/images/vendor/small/20190108/avantcoequipment_logo_hr.jpg",
  },
  {
    description: "Avantco\u000ARefrigeration",
    link: "/vendor/avantco-refrigeration.html",
    imagePath: "/images/vendor/small/20150323/avantcorefrigeration_logo_hr.jpg",
  },
  {
    description: "Beverage-Air",
    link: "/vendor/beverage-air.html",
    imagePath: "/images/vendor/small/20150323/beverageair_logo_hr.jpg",
  },
  {
    description: "Cambro",
    link: "/vendor/cambro.html",
    imagePath: "/images/vendor/small/20221228/cambro__logo_hr.jpg",
  },
  {
    description: "Carlisle",
    link: "/vendor/carlisle.html",
    imagePath: "/images/vendor/small/20150323/carlisle_logo_hr.jpg",
  },
  {
    description: "Edlund",
    link: "/vendor/edlund.html",
    imagePath:
      "//www.webstaurantstore.com/uploads/images/2022/1/vendor/edlund_logo_tall.jpg",
  },
  {
    description: "Jackson",
    link: "/vendor/jackson.html",
    imagePath: "/images/vendor/small/20160919/jackson_logo_hr.jpg",
  },
  {
    description: "Lancaster\u000ATable\u000A&\u000ASeating",
    link: "/vendor/lancaster-table-seating.html",
    imagePath:
      "//www.webstaurantstore.com/uploads/seo_category/2024/3/lts_image.jpg",
  },
  {
    description: "Lavex",
    link: "/vendor/lavex.html",
    imagePath: "/uploads/design/2024/1/lavex-thumbnail.jpg",
  },
  {
    description: "Lavex\u000APro",
    link: "/vendor/lavex-pro.html",
    imagePath: "/uploads/design/2024/1/lavex-pro-thumbnail.jpg",
  },
  {
    description: "Mercer\u000ACulinary",
    link: "/vendor/mercer-culinary.html",
    imagePath: "/images/vendor/small/20171116/mercer_logo_hr.jpg",
  },
  {
    description: "Noble\u000AProducts",
    link: "/vendor/noble-products.html",
    imagePath: "/images/vendor/small/20150323/nobleproducts_logo_hr.jpg",
  },
  {
    description: "Regal\u000ASpice",
    link: "/vendor/regal-spice.html",
    imagePath: "/images/vendor/small/20150323/regalspice_logo_hr.jpg",
  },
  {
    description: "Regency",
    link: "/vendor/regency.html",
    imagePath:
      "//www.webstaurantstore.com/uploads/seo_category/2024/3/regency_image.jpg",
  },
  {
    description: "Vollrath",
    link: "/vendor/vollrath.html",
    imagePath: "/images/vendor/small/20150323/vollrath_logo_hr.jpg",
  },
];

export default brandSection;
